var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1334 9.05866C10.05 9.05033 9.95005 9.05033 9.85838 9.05866C7.87505 8.99199 6.30005 7.36699 6.30005 5.36699C6.30005 3.32533 7.95005 1.66699 10 1.66699C12.0417 1.66699 13.7 3.32533 13.7 5.36699C13.6917 7.36699 12.1167 8.99199 10.1334 9.05866Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9666 12.133C3.94993 13.483 3.94993 15.683 5.9666 17.0247C8.25827 18.558 12.0166 18.558 14.3083 17.0247C16.3249 15.6747 16.3249 13.4747 14.3083 12.133C12.0249 10.608 8.2666 10.608 5.9666 12.133Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.efad5006b91f57201ce1bdd6f88bd4b8.svg";
export { ForwardRef as ReactComponent };